<template>
  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="66" height="66"
       viewBox="0 0 66 66" class="pipelinecirclefilledicon">
    <defs>
      <filter id="a" x="0" y="0" width="66" height="66" filterUnits="userSpaceOnUse">
        <feOffset dy="3" input="SourceAlpha"/>
        <feGaussianBlur stdDeviation="3" result="b"/>
        <feFlood flood-opacity="0.161"/>
        <feComposite operator="in" in2="b"/>
        <feComposite in="SourceGraphic"/>
      </filter>
    </defs>
    <g class="b" transform="matrix(1, 0, 0, 1, 0, 0)">
      <circle class="a" cx="24" cy="24" :r="small ? 16 : 24" transform="translate(9 6)"/>
    </g>
  </svg>
</template>

<script>
export default {
  name: "PipelineCircleFilledIcon",
  props: {
    small: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.a {
  fill: #dd227b;
}

.b {
  filter: url(#a);
}
</style>
